import { SelectElementMapper } from '../../_services/types/commons.type';
import { SharedFunnelDatalayerEvent } from '../../_services/types/datalayer.types';
import {
  BusinessThingDamageCause,
  getBusinessThingDamageCauseLabel,
} from '../../enums/business/business-thing-damage-cause.enum';
import {
  getPreferredContactMethodLabel,
  PreferredContactMethod,
} from '../../enums/preferred-contact-method.enum';

export const BUSINESS_COMPANY_THINGS_BASE_URL = 'choses-entreprise';

export const BUSINESS_COMPANY_THINGS_FUNNEL_EVENT_BASE: SharedFunnelDatalayerEvent = {
  product_category: 'CHOSES_ENTREPRISE',
  product_name: 'Claim',
  funnel_complete: false,
  get event() {
    return `${this.product_name}_${this.product_category}`;
  },
};

export const BUSINESS_COMPANY_THINGS_STEPS = {
  GENERAL_INFO: {
    url: 'informations-generales',
    step: [3, 1],
    datalayerEvent: {
      ...BUSINESS_COMPANY_THINGS_FUNNEL_EVENT_BASE,
      funnel_stage: 4,
      stage_name: 'Informations generales',
    },
  },
  DAMAGE_CAUSE: {
    url: 'cause-dommage',
    step: [3, 2],
    datalayerEvent: {
      ...BUSINESS_COMPANY_THINGS_FUNNEL_EVENT_BASE,
      funnel_stage: 5,
      stage_name: 'Cause dommage',
    },
  },
  DAMAGED_GOODS: {
    url: 'biens-endommages',
    step: [3, 3],
    datalayerEvent: {
      ...BUSINESS_COMPANY_THINGS_FUNNEL_EVENT_BASE,
      funnel_stage: 6,
      stage_name: 'Biens endommages',
    },
  },
  DOCUMENTS: {
    url: 'documents',
    step: [3, 4],
    datalayerEvent: {
      ...BUSINESS_COMPANY_THINGS_FUNNEL_EVENT_BASE,
      funnel_stage: 7,
      stage_name: 'Documents',
    },
  },
  VALIDATION: {
    url: 'validation',
    step: [4, 1],
    datalayerEvent: {
      ...BUSINESS_COMPANY_THINGS_FUNNEL_EVENT_BASE,
      funnel_stage: 8,
      stage_name: 'Validation',
    },
  },
} as const;

export const BUSINESS_COMPANY_THINGS_DAMAGE_CAUSE_OPTIONS: SelectElementMapper<BusinessThingDamageCause> =
  {
    [BusinessThingDamageCause.FIRE]: {
      value: BusinessThingDamageCause.FIRE,
      label: getBusinessThingDamageCauseLabel(BusinessThingDamageCause.FIRE),
    },
    [BusinessThingDamageCause.WATER]: {
      value: BusinessThingDamageCause.WATER,
      label: getBusinessThingDamageCauseLabel(BusinessThingDamageCause.WATER),
    },
    [BusinessThingDamageCause.THEFT]: {
      value: BusinessThingDamageCause.THEFT,
      label: getBusinessThingDamageCauseLabel(BusinessThingDamageCause.THEFT),
    },
    [BusinessThingDamageCause.VANDALISM]: {
      value: BusinessThingDamageCause.VANDALISM,
      label: getBusinessThingDamageCauseLabel(BusinessThingDamageCause.VANDALISM),
    },
    [BusinessThingDamageCause.BREAKAGE]: {
      value: BusinessThingDamageCause.BREAKAGE,
      label: getBusinessThingDamageCauseLabel(BusinessThingDamageCause.BREAKAGE),
    },
    [BusinessThingDamageCause.NATURAL_DISASTER]: {
      value: BusinessThingDamageCause.NATURAL_DISASTER,
      label: getBusinessThingDamageCauseLabel(BusinessThingDamageCause.NATURAL_DISASTER),
    },
    [BusinessThingDamageCause.OTHER]: {
      value: BusinessThingDamageCause.OTHER,
      label: getBusinessThingDamageCauseLabel(BusinessThingDamageCause.OTHER),
    },
  };

export const BUSINESS_COMPANY_THINGS_CONTACT_METHOD_OPTIONS: SelectElementMapper<PreferredContactMethod> =
  {
    [PreferredContactMethod.EMAIL]: {
      value: PreferredContactMethod.EMAIL,
      label: getPreferredContactMethodLabel(PreferredContactMethod.EMAIL),
    },
    [PreferredContactMethod.PHONE]: {
      value: PreferredContactMethod.PHONE,
      label: getPreferredContactMethodLabel(PreferredContactMethod.PHONE),
    },
  };
